import { render } from "./AiAssistant.vue?vue&type=template&id=85786c92&scoped=true"
import script from "./AiAssistant.vue?vue&type=script&lang=js"
export * from "./AiAssistant.vue?vue&type=script&lang=js"

import "./AiAssistant.vue?vue&type=style&index=0&id=85786c92&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85786c92"]])

export default __exports__